export class ColleagueEntity {
    email: string;
    name: string;
    total : number;

    constructor(data?: Partial<ColleagueEntity>) {
        this.email = data?.email || "";
        this.name = data?.name || "";
        this.total = data?.total || 0;
    }
}